export default __webpack_public_path__ + "static/media/goshen86.deea6a9d.jpg";